import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, mergeMap, switchMap, throwError } from 'rxjs';
import {
  CAMBIO_PASSWORD,
  CAMBIO_PASSWORD_SUCCESS,
  LOGIN,
  LOGIN_RESET,
  LOGIN_SUCCESS,
  LOGOUT,
} from './login.actions';
import { ILoginState } from './login';
import { setCookie } from '@poste-click-connect/shared-ui';
import { Router } from '@angular/router';
import { HttpErrorResponse } from '@angular/common/http';
import { LoginCode } from '../../enum/login-code.enum';
import { LoginPayload } from '../../interfaces/login-payload';
import { ApiService } from '../../services/api.service';
import { Path } from '../../enum/path.enum';
import { IResponseCambioPassword } from '../../interfaces/change-password';
import { EsitoEnum } from '../../enum/esito.enum';
import { RolesBoEnum } from '../../enum/role.enum';

@Injectable()
export class LoginEffects {
  retrieveProfilerUser$ = createEffect(() => {
    let username = '';
    return this.actions$.pipe(
      ofType(LOGIN),
      switchMap(({ body }: { body: LoginPayload }) => {
        username = body.username;
        return this.api.login(body);
      }),
      mergeMap((responseLogin: ILoginState) => {
        const isNavigationAvailable =
          responseLogin.esito === LoginCode.AVAILABLE ||
          responseLogin.esito === LoginCode.CHANGE_PASSWORD;

        if (isNavigationAvailable) {
          const today = new Date();

          const expirationDate = today.getTime() + 500000;

          setCookie(
            'accessToken',
            responseLogin.authToken,
            `${expirationDate}`,
            window.location.hostname,
            true
          );

          if (responseLogin.utente) {
            responseLogin = {
              ...responseLogin,
              utente: { ...(responseLogin.utente || {}), username },
            };
          } else {
            responseLogin = {
              ...responseLogin,
              utente: {
                username,
                firstName: '',
                giorniAnticipoFerie: 0,
                lastName: '',
                profili: [],
                servizioDisattivazionePPS: false,
                tabRicercaFraz: false,
              },
            };
          }

          setCookie(
            'user',
            JSON.stringify(responseLogin.utente),
            `${expirationDate}`,
            window.location.hostname,
            true
          );

          if (responseLogin.esito === LoginCode.AVAILABLE) {
            let defaultUrl = `/${Path.REPORT_RETE_TERZA}`;

            if (responseLogin.utente?.profili.includes(RolesBoEnum.APP)) {
              defaultUrl = `/${Path.UTILITY}/${Path.MATERIAL_CATALOGUE}`;
            } else if (
              responseLogin.utente?.profili.includes(RolesBoEnum.APPRT)
            ) {
              defaultUrl = `/${Path.UTILITY}/${Path.ORDER_CREATE}`;
            } else if(responseLogin.utente?.profili[0] === RolesBoEnum.OPTER) {
              defaultUrl = `/${Path.UTILITY}/${Path.PIN_RECOVERY}`;
            } else if (responseLogin.utente?.siglaRt) {
              defaultUrl = `/${Path.POINT_POST}/${responseLogin.utente.siglaRt}`;
            }

            this.router.navigateByUrl(defaultUrl);
          }
          if (responseLogin.esito === LoginCode.CHANGE_PASSWORD) {
            this.router.navigateByUrl(`/${Path.CAMBIO_PASSWORD}`);
          }
        }
        return [LOGIN_SUCCESS({ responseLogin })];
      }),
      catchError((error: HttpErrorResponse) => {
        return throwError({ error });
      })
    );
  });

  retrieveCambioPassword$ = createEffect(() => {
    let username = '';
    return this.actions$.pipe(
      ofType(CAMBIO_PASSWORD),
      switchMap(({ payload }) => {
        username = payload.username;
        return this.api.retrieveCambioPassword(payload);
      }),
      mergeMap((responseCambioPassword: IResponseCambioPassword) => {
        const isOK = responseCambioPassword.esito === EsitoEnum.NUMBER_0;

        if (isOK) {
          const today = new Date();
          const expirationDate = today.getTime() + 500000;
          setCookie(
            'accessToken',
            responseCambioPassword.authToken,
            `${expirationDate}`,
            window.location.hostname,
            true
          );
        }

        return [CAMBIO_PASSWORD_SUCCESS({ responseCambioPassword })];
      }),
      catchError((error: HttpErrorResponse) => {
        return throwError({ error });
      })
    );
  });

  retriveLogout$ = createEffect(() =>
    this.actions$.pipe(
      ofType(LOGOUT),
      switchMap(() => this.api.retriveLogout()),
      mergeMap(() => {
        return [LOGIN_RESET()];
      }),
      catchError((error: HttpErrorResponse) => {
        return throwError({ error });
      })
    )
  );

  constructor(
    private actions$: Actions,
    private api: ApiService,
    private router: Router
  ) {}
}
